module.exports = __webpack_public_path__ + "img/icon-themes.5715c478.svg";